import { DatePipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as Global from '../../../../global';
import { HelpersService } from '../../../../services/helpers.service';
import { NavService } from '../../../../services/nav.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ToastService } from '@app/services/toast.service';
import { MatRadioModule } from '@angular/material/radio';
import { SupportService } from '../support.service';
import { PermissionsService } from '@app/services/permissions.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'contact-support',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    NgIf,
    MatRadioModule,
  ],
  templateUrl: './contact-support.component.html',
  styleUrl: './contact-support.component.scss',
})
export class ContactSupportComponent {
  @Input() data: any = null;
  Global = Global;
  isLoading: boolean = false;
  claims: any = [];
  notifications: any = [];
  formGroup!: FormGroup;
  constructor(
    private fb: FormBuilder,
    public toastr: ToastService,
    public navService: NavService,
    private supportService: SupportService,
    private helpers: HelpersService,
    public permissions: PermissionsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }
  async ngOnInit() {
    this.claims = await this.permissions.getAllClaims();
    this.formGroup = this.fb.group({
      queryText: [null, [Validators.required, Validators.pattern(/\S/)]],
      contactNo: [null, [Validators.required, Validators.pattern(/^\d{10}$/)]],
      documentData: [null],
      documentName: [null],
      issueNo: [0],
      issueText: ['I need a solution ASAP!'],
      customText: [null],
    });
  }
  async ngOnChanges() {
    this.claims = await this.permissions.getAllClaims();
    this.formGroup = this.fb.group({
      queryText: [null, Validators.compose([Validators.required, Validators.pattern(/\S/)])],
      contactNo: [null, Validators.compose([Validators.required, Validators.pattern(/^\d{10}$/)])],
      documentData: [null, Validators.compose([])],
      documentName: [null, Validators.compose([])],
      issueNo: [0, Validators.compose([])],
      issueText: ['I need to solution ASAP!', Validators.compose([])],
      customText: [null, Validators.compose([])],
    });
  }
  clear() {
    this.formGroup.patchValue({
      documentData: null,
      documentName: null,
    });
  }
  onSubmit(event: any) {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      let formData: any = this.formGroup.value
      this.supportService.contactSupport(formData).subscribe({
        next: (res) => {
          this.toastr.success(
            `Request Sent successfully`
          );
          this.navService.openSideNav({ toogle: true })
          this.navService.triggerRefresh('support-request');
        },
        error: (err) => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
        complete: () => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
      });
    }
  }
  navigateToList() {
    this.router.navigateByUrl("/settings/support-request")
    this.navService.openSideNav({ toogle: true })
  }
}
